export const getters = {
  isAuthenticated(state) {
    return state.auth.loggedIn
  },
  loggedInUser(state) {
    return state.auth.user
  },
  locale(state) {
    return state.lang.locale
  },
  currentPage(state) {
    return state.currentPage
  },
  showSearch(state) {
    return state.showSearch
  },
  isLoading: (state) => state.isLoading,
  layoutData: (state) => state.layoutData,
}

export const mutations = {
  changeLocale(state, payload) {
    state.lang.locale = payload
  },
  changeCurrentPage(state, payload) {
    state.currentPage = payload
  },
  changeShowSearch(state, payload) {
    state.showSearch = payload
  },
  isLoading(state, payload) {
    state.isLoading = payload
  },
  layoutData(state, payload) {
    state.layoutData = payload
  },
}

export const actions = {
  nuxtServerInit({ commit }, { app, req, res }) {
    const locale = app.$cookies.get('locale')
    if (locale) {
      app.i18n.setLocale(locale)
      app.$cookies.set('locale', locale, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
    } else {
      commit('changeLocale', process.env.VUE_APP_LANG ?? app.i18n.locale)
      app.$cookies.set('locale', process.env.VUE_APP_LANG ?? app.i18n.locale, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
    }
  },
}

export const state = () => ({
  currentPage: '',
  showSearch: false,
  isLoading: false,
  layoutData: null,
})
